import styles from './Footer.module.scss';
import * as React from 'react';

interface FooterProps {
  footerContent: {
    copyright?: string;
    privacyPolicyLink?: string;
    privacyPolicy?: string;
    privacySettings?: string;
    doNotSell?: string;
    doNotSellLink?: string;
    termsOfUseLink?: string;
    termsOfUse?: string;
  };
}

const Footer: React.FC<FooterProps> = ({ footerContent }) => {
  const content = footerContent;
  const [isCaliforniaUser, setIsCaliforniaUser] = React.useState(true);

  React.useEffect(() => {
    const handleOneTrustReady = () => {
      const locationOfUser = window.OneTrust.getGeolocationData();
      setIsCaliforniaUser(locationOfUser?.country === 'US' && locationOfUser?.state === 'CA');
    };

    window.addEventListener('oneTrustReady', handleOneTrustReady);
    
    return () => {
      window.removeEventListener('oneTrustReady', handleOneTrustReady);
    };
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.copyright}>
          {`©${new Date().getFullYear()} ${content.copyright}`}
        </div>
        <div className={styles.links}>
          {content?.privacyPolicyLink &&
            content?.privacyPolicy && (
              <a href={content.privacyPolicyLink} className={styles.linkButton} target="_blank" rel="noopener noreferrer">
                {content.privacyPolicy}
              </a>
            )}
          {!isCaliforniaUser ? (
            <button
              className={styles.linkButton}
              type="button"
              onClick={() => window.OneTrust?.ToggleInfoDisplay()}
            >
              {content.privacySettings}
            </button>
          ) : (
            <button
              className={styles.linkButton}
              type="button"
              onClick={() => window.OneTrust?.ToggleInfoDisplay()}
            >
              {content.doNotSell}
            </button>
          )}
          {content?.termsOfUseLink && content?.termsOfUse && (
            <a href={content.termsOfUseLink} className={styles.linkButton} target="_blank" rel="noopener noreferrer">
              {content.termsOfUse}
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;